import {createApiAction, GetAllMaterialityUrl, UpdateDeleteMaterialityUrl, UpdateMaterialityByIdUrl, CreateMaterialityUrl} from '../apiUrls';
import {
	CREATE_MATERIALITY,
	DELETE_MATERIALITY,
	GET_MATERIALITY,
	UPDATE_MATERIALITY,
	UPDATE_MATERIALITY_BASIS_ADJUSTED,
	UPDATE_MATERIALITY_STATE_BY_ID
} from '../actiontypes';

export const getMateriality = (engagementId, trackWithArea = undefined, queryStringParams) => {
	const url = GetAllMaterialityUrl(engagementId, queryStringParams);

	return createApiAction(GET_MATERIALITY, url, 'GET', undefined, trackWithArea, {resolve: true});
};

export const updateMaterialityById = (engagementId, materialityId, data) => {
	const url = UpdateMaterialityByIdUrl(engagementId, materialityId);

	return createApiAction(UPDATE_MATERIALITY, url, 'PATCH', data, undefined, {resolve: true});
};

export const updateMaterialityStoreById = (materialityId, data) => {
	return {
		type: UPDATE_MATERIALITY_STATE_BY_ID,
		data: data,
		materialityId: materialityId
	};
};

export const updateMateriality = (engagementId, materialityId, data) => {
	const url = UpdateDeleteMaterialityUrl(engagementId, materialityId);

	return createApiAction(UPDATE_MATERIALITY, url, 'PUT', data, undefined, {resolve: true});
};

export const patchMateriality = (engagementId, materialityId, data) => {
	const url = UpdateDeleteMaterialityUrl(engagementId, materialityId);

	return createApiAction(UPDATE_MATERIALITY, url, 'PATCH', data, undefined, {resolve: true});
};

export const patchMaterialityAdjustedBasis = (engagementId, materialityId, data) => {
	const url = UpdateDeleteMaterialityUrl(engagementId, materialityId);

	return createApiAction(UPDATE_MATERIALITY_BASIS_ADJUSTED, url, 'PATCH', data, undefined, {resolve: true});
};

export const createMateriality = (engagementId, data) => {
	const url = CreateMaterialityUrl(engagementId);

	return createApiAction(CREATE_MATERIALITY, url, 'POST', data, undefined, {resolve: true});
};

export const deleteMateriality = (engagementId, materialityId) => {
	const url = UpdateDeleteMaterialityUrl(engagementId, materialityId);

	return createApiAction(DELETE_MATERIALITY, url, 'DELETE', undefined, undefined, {resolve: true, materialityId});
};
